var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3883 1.59961H9.61156C8.4635 1.59961 7.40343 2.21552 6.8354 3.21138L0.423025 14.4098C-0.141008 15.3936 -0.141008 16.6055 0.423025 17.5893L6.8354 28.7877C7.40743 29.7836 8.4635 30.3995 9.61156 30.3995H22.3883C23.5364 30.3995 24.5964 29.7836 25.1645 28.7877L31.5769 17.5893C32.1409 16.6055 32.1409 15.3936 31.5769 14.4098L25.1645 3.21138C24.5964 2.21552 23.5364 1.59961 22.3883 1.59961Z",
    fill: "url(#paint0_linear_3263_66258)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M31.5772 14.4098L25.1649 3.21138C24.5968 2.21552 23.5368 1.59961 22.3887 1.59961H16.0283V30.3955H22.3887C23.5368 30.3955 24.5968 29.7796 25.1649 28.7837L31.5772 17.5853C32.1413 16.6015 32.1413 15.3936 31.5772 14.4098Z",
    fill: "#065D45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3883 4.15924C22.6163 4.15924 22.8283 4.28323 22.9443 4.4832L29.3567 15.6816C29.4687 15.8776 29.4687 16.1215 29.3567 16.3175L22.9443 27.5159C22.8323 27.7159 22.6163 27.8399 22.3883 27.8399H9.61156C9.38355 27.8399 9.17154 27.7159 9.05553 27.5159L2.64315 16.3175C2.53115 16.1215 2.53115 15.8776 2.64315 15.6816L9.05553 4.4832C9.16754 4.28323 9.38355 4.15924 9.61156 4.15924H22.3883ZM22.3883 1.59961H9.61156C8.4635 1.59961 7.40343 2.21552 6.8354 3.21138L0.423025 14.4098C-0.141008 15.3936 -0.141008 16.6055 0.423025 17.5893L6.8354 28.7877C7.40743 29.7836 8.4635 30.3995 9.61156 30.3995H22.3883C23.5364 30.3995 24.5964 29.7836 25.1645 28.7877L31.5769 17.5893C32.1409 16.6055 32.1409 15.3936 31.5769 14.4098L25.1645 3.21138C24.5964 2.21552 23.5364 1.59961 22.3883 1.59961Z",
    fill: "#25D695"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8003 18.0849C12.8003 18.1009 12.8003 18.1169 12.8043 18.1329L11.2882 19.1327C11.2322 19.0207 11.2002 18.8967 11.2002 18.7688V13.2256C11.2002 13.0936 11.2322 12.9656 11.2922 12.8496L12.8003 13.8575C12.7963 13.8735 12.7963 13.8935 12.7963 13.9135V18.0849H12.8003Z",
    fill: "url(#paint1_linear_3263_66258)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 20.3766V22.2363C15.8444 22.2363 15.6923 22.1923 15.5563 22.1003L11.5561 19.4327C11.4401 19.3567 11.3481 19.2487 11.2881 19.1288L12.8042 18.1289C12.8162 18.2729 12.8962 18.4009 13.0162 18.4809L15.7363 20.2926C15.8164 20.3486 15.9084 20.3766 16.0004 20.3766Z",
    fill: "url(#paint2_linear_3263_66258)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7123 19.1289C20.6523 19.2489 20.5603 19.3529 20.4443 19.4329L16.444 22.1005C16.308 22.1885 16.156 22.2365 16 22.2365V20.3768C16.092 20.3768 16.184 20.3488 16.268 20.2968L18.9882 18.485C19.1122 18.4011 19.1882 18.2691 19.2002 18.1211L20.7123 19.1289Z",
    fill: "url(#paint3_linear_3263_66258)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7998 13.2244V18.7676C20.7998 18.8956 20.7678 19.0196 20.7118 19.1276L19.1997 18.1197C19.1997 18.1077 19.1997 18.0957 19.1997 18.0837V13.9043L20.7278 12.8965C20.7758 12.9965 20.7998 13.1085 20.7998 13.2244Z",
    fill: "url(#paint4_linear_3263_66258)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7283 12.8993L19.2002 13.9072C19.2002 13.7472 19.1202 13.5992 18.9882 13.5112L16.268 11.6995C16.188 11.6475 16.096 11.6195 16 11.6195V9.75977C16.156 9.75977 16.308 9.80376 16.444 9.89575L20.4443 12.5634C20.5723 12.6474 20.6683 12.7633 20.7283 12.8993Z",
    fill: "url(#paint5_linear_3263_66258)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 9.75977V11.6195C15.9078 11.6195 15.8158 11.6475 15.7318 11.6995L13.0116 13.5112C12.9316 13.5672 12.8676 13.6432 12.8316 13.7312C12.8156 13.7712 12.8036 13.8152 12.7996 13.8592L11.2915 12.8513C11.3515 12.7353 11.4435 12.6354 11.5555 12.5634L15.5558 9.89575C15.6918 9.80776 15.8438 9.75977 15.9998 9.75977Z",
    fill: "url(#paint6_linear_3263_66258)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2002 13.9089V18.0803C19.2002 18.2402 19.1202 18.3922 18.9882 18.4802L16.268 20.292C16.108 20.3999 15.896 20.3999 15.736 20.292L13.0158 18.4802C12.8838 18.3922 12.7998 18.2402 12.7998 18.0803V13.9089C12.7998 13.8449 12.8118 13.7849 12.8358 13.7289C12.8718 13.6409 12.9318 13.5649 13.0158 13.5089L15.736 11.6972C15.816 11.6452 15.908 11.6172 16 11.6172C16.092 11.6172 16.184 11.6452 16.268 11.6972L18.9882 13.5089C19.1202 13.6009 19.2002 13.7489 19.2002 13.9089Z",
    fill: "#7AE5C1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4004 11.1982L22.0004 9.99816L20.8003 9.59814L22.0004 9.19812L22.4004 7.99805L22.8004 9.19812L24.0005 9.59814L22.8004 9.99816L22.4004 11.1982Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8005 25.0884L20.6005 24.4883L20.0005 24.2883L20.6005 24.0883L20.8005 23.4883L21.0005 24.0883L21.6006 24.2883L21.0005 24.4883L20.8005 25.0884Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34764 17.2656L6.07963 16.4575L5.26758 16.1855L6.07963 15.9175L6.34764 15.1055L6.61966 15.9175L7.4277 16.1855L6.61966 16.4575L6.34764 17.2656Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3263_66258",
    x1: 4.01975,
    y1: 27.9753,
    x2: 26.6439,
    y2: 5.34659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0277605,
    stopColor: "#1DA975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8798,
    stopColor: "#05E190"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3263_66258",
    x1: 11.2002,
    y1: 15.9904,
    x2: 12.8035,
    y2: 15.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25AB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66C4A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3263_66258",
    x1: 12.8355,
    y1: 21.9556,
    x2: 15.3613,
    y2: 17.9772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2452,
    stopColor: "#66C4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7353,
    stopColor: "#25AB83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3263_66258",
    x1: 18.4352,
    y1: 20.7986,
    x2: 17.599,
    y2: 19.5651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25AB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66C4A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3263_66258",
    x1: 19.1981,
    y1: 16.0124,
    x2: 20.7998,
    y2: 16.0124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0270717,
    stopColor: "#25AB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66C4A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3263_66258",
    x1: 18.4777,
    y1: 11.1572,
    x2: 17.5283,
    y2: 12.6082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25AB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66C4A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3263_66258",
    x1: 13.5203,
    y1: 11.1132,
    x2: 14.5858,
    y2: 12.7425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9729,
    stopColor: "#25AB83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.97037f816ea8fbd97b47f59673bc70ff.svg";
export { ForwardRef as ReactComponent };